import { LucideProps } from "lucide-react";

const SpotifyIcon = (props: LucideProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M8 15c3-1 5-1 8 1" />
    <path d="M7 12.5c4-1.5 6.5-1.5 10.5 1" />
    <path d="M6 10c4.5-2 8-2 12.5 1" />
  </svg>
);

export default SpotifyIcon;
